import {json, spine, texture} from "p3";
import common from "../common";
import settings from "../settings";
import EquipTab from "../ui/inventory/EquipTab";
import SatchelTab from "../ui/inventory/SatchelTab";
import {iswebfont, locale, resizeLabelToFitText} from "../utils";
import GameScene from "./GameScene";
import MenuScene from "./MenuScene";
import { Skin } from "@pixi-spine/runtime-4.1";
import HealthBar from "../ui/health/HealthBar";
import definitions from "../definitions";
import CoinCounterPanel from "../ui/CoinCounterPanel";
import Swiper from "../ui/Swiper";

export default class InventoryScene extends MenuScene {
    /**
     * @param {Inventory} inventory
     */
    constructor(inventory) {
        super("inventory");

        this._inventory = inventory;

        this._popUpFill = null;
        this._closeButton = null;

        this._bag = null;
        this._panel = null;
        this._coinHolder = null;

        this._satchelTab = null;
        this._equipTab = null;

        this._ivandoe = null;

        this._swiper = null;

        this.healthBar = null;

        this._satchelPage = new SatchelTab(this._inventory);
        this._equipPage = new EquipTab(this._inventory);
    }

    init() {
        super.init();
    }

    onSceneLoaded() {
        super.onSceneLoaded();

        this.interactive = true;

        if (!common.saveData.settings.musicMute) {
            P3.audio.playMusic("music_map_loop");
        }

        this.createFill();
        this.createTitleBanner(locale('ui_inventory_title'));

        this._bag = new PIXI.Sprite(texture("inventory_bag"));
        this._bag.anchor.set(0.5, 1);
        this._bag.x = common.STAGE_WIDTH/2;
        this._bag.y = common.STAGE_HEIGHT;
        this.addChild(this._bag);
        

        this._panel = new PIXI.Container();
        this._panel.x = (common.STAGE_WIDTH/2);
        this._panel.y = (common.STAGE_HEIGHT/2) + (settings.PHASE > 1 ? 84 : 70);
        this.addChild(this._panel);

        const satchelTabs = [];
        const equipTabs = [];
        const tabsArr = [satchelTabs, equipTabs];

        for (let i = 0; i < tabsArr.length; i++) {
            for (let j = 0; j < 2; j++) {
                let spr = new PIXI.NineSlicePlane(texture("inventory_panel_tab"), 25, 25, 25, 25);
                if (j == 0) {
                    spr.tint = 0xc7c6c5;
                    if (settings.PHASE > 1) {
                        this._panel.addChild(spr);
                    }
                }
                tabsArr[i][j] = spr;
            }
        }

        const panelSpr = new PIXI.Sprite(texture("inventory_panel"));
        panelSpr.anchor.set(0.5, 0.5);
        this._panel.addChild(panelSpr);

        if (settings.PHASE > 1) {
            this._panel.addChild(satchelTabs[1]);
            this._panel.addChild(equipTabs[1]);
        }

        let backing, label;
        this._satchelTab = P3.Button.create(PIXI.Texture.EMPTY);
        this._satchelTab.animate = false;
        this._satchelTab.tab = satchelTabs[1];
            backing = new PIXI.Sprite(PIXI.Texture.EMPTY);
            backing.anchor.set(0.5);
            this._satchelTab.addChild(backing);

            if (!iswebfont()) {
                label = new PIXI.BitmapText(locale("ui_inventory_items").toUpperCase(), {
                    fontName: "Alghera Pro",
                    fontSize: 32,
                    align: "left",
                    tint: 0x000000
                });
            } else {
                label = new PIXI.Text(locale("ui_inventory_items").toUpperCase(), {
                    fontFamily: "FredFredBurger",
                    fontSize: 32,
                    align: "left",
                    fill: 0x0
                });
            }
            label.y = !iswebfont() ? 0 : -3;
            label.anchor.set(0.5);
            this._satchelTab.addChild(label);
            backing.width = label.width + 80;
            backing.height = label.height + 40;
        this._satchelTab.signals.click.add(this.showSatchelTab, this);
        this._panel.addChild(this._satchelTab);

        this._equipTab = P3.Button.create(PIXI.Texture.EMPTY);
        this._equipTab.animate = false;
        this._equipTab.tab = equipTabs[1];
            backing = new PIXI.Sprite(PIXI.Texture.EMPTY);
            backing.anchor.set(0.5);
            this._equipTab.addChild(backing);
            if (!iswebfont()) {
                label = new PIXI.BitmapText(locale("ui_inventory_equip").toUpperCase(), {
                    fontName: "Alghera Pro",
                    fontSize: 32,
                    align: "left",
                    tint: 0x000000
                });
            } else {
                label = new PIXI.Text(locale("ui_inventory_equip").toUpperCase(), {
                    fontFamily: "FredFredBurger",
                    fontSize: 32,
                    align: "left",
                    fill: 0x0
                });
            }
            label.y = !iswebfont() ? 0 : -3;
            label.anchor.set(0.5);
            this._equipTab.addChild(label);
            backing.width = label.width + 80;
            backing.height = label.height + 40;
        this._equipTab.signals.click.add(this.showEquipTab, this);
        this._panel.addChild(this._equipTab);

        this._satchelTab.y = this._equipTab.y = -(this._panel.height/2) - 14.5;
        this._satchelTab.x = -(this._satchelTab.width/2);
        this._equipTab.x = (this._equipTab.width/2);
        
        const tabButtons = [this._satchelTab, this._equipTab];
        for (let i = 0; i < tabsArr.length; i++) {
            for (let j = 0; j < tabsArr[i].length; j++) {
                tabsArr[i][j].width = tabButtons[i].width;
                tabsArr[i][j].x = tabButtons[i].x - (tabsArr[i][j].width/2);
                tabsArr[i][j].y = tabButtons[i].y - (tabsArr[i][j].height/2);
            }
        }
        //console.log(tabsArr);

        if (settings.PHASE == 1) {
            this._satchelTab.visible = this._equipTab.visible = false;
        }
        
        this._panel.addChild(this._satchelPage);
        this._equipPage.visible = false;
        this._panel.addChild(this._equipPage);

        this.signalListeners.push(
            this._equipPage.signals.itemSelected.add((data, buttonText, shopId) => {
                //console.log(data);
                this.showItemPanel(data, buttonText, () => {
                    if(buttonText == "ui_inventory_unequip_item") {
                        this._equipPage.unequipItem(data.type);
                    } else if (buttonText == "ui_inventory_equip_item") {
                        common.tracking.trackEvent(definitions.TRACKING.EVENT_TYPE.INTERACTION, {
                            section: common.tracking.getSection(),
                            contenttitle: json('locale')[data.name].en,
                            interaction: "inventory equip",
                            progress: common.tracking.progress,
                            interactionevent: 1
                        });
                        this._equipPage.setEquippedItem(data.type, data.id);
                    } else if (buttonText == "ui_inventory_go_to_shop") {
                        this.animateHide(() => {
                            this.signals.next.dispatch('shop');
                        });
                    }
                });
            }, this)
        );
        
        this._shopButton = P3.Button.create(texture("btn_shop"));
        this._shopButton.overSoundName = "sfx_btn_generic_rollover";
        this._shopButton.clickSoundName = "sfx_btn_bag_open";
        this._shopButton.defaultSize = {width:this._shopButton.width, height:this._shopButton.height};
        this._shopButton.interactive = true;
        this.signalListeners.push(
            this._shopButton.signals.click.add(() => {
                this.animateHide(() => {
                    this.signals.next.dispatch('shop');
                });
            })
        );
        this.addChild(this._shopButton);
        
        this._coinHolder = new CoinCounterPanel();
        this._coinHolder.x = (common.STAGE_WIDTH / 2) - 10;
        this._coinHolder.y = this._titleBanner.y + 50;
        this.addChild(this._coinHolder);
        this._coinHolder.coinAmount = common.saveData.activeSlot.coins;

        this._closeButton = this.addCloseButton((panelSpr.width/2), -(panelSpr.height/2));
        this._panel.addChild(this._closeButton);
        this._closeButton.overSoundName = "sfx_btn_generic_rollover";
        this._closeButton.clickSoundName = "sfx_btn_bag_close";

        if (settings.PHASE > 1) {
            this._ivandoe = new PIXI.spine.Spine(spine("char_ivandoe"));
            this._ivandoe.skeleton.setSlotsToSetupPose();
            this._ivandoe.skeleton.setToSetupPose();
            this._ivandoe.autoUpdate = false;
            this._ivandoe.state.setAnimation(0, 'body_idle_00', true);
            this._ivandoe.state.setAnimation(1, 'legs_idle_00', true);
            this._ivandoe.position.set((common.STAGE_WIDTH/2)-350, common.STAGE_HEIGHT*1.5);
            this._ivandoe.scale.set(0.5, 0.5);
            this.addChild(this._ivandoe);

            this.setIvandoeSkin();
        }

        this._downButton = P3.Button.create(
            texture("btn_small_out"),
            texture("btn_small_out"),
            texture("btn_small_out"),
            texture("btn_icon_small_next"),
        );
        this._downButton._icon.rotation = 90 * PIXI.DEG_TO_RAD;
        this._downButton.x = (panelSpr.width/2);
        this._downButton.y = 100;
        this._downButton.signals.click.add(() => {
            if (this._satchelPage.visible) {
                this._satchelPage.scroll(1);
            } else if (this._equipPage.visible) {
                this._equipPage.scroll(1);
            }
            this.assessScrollButtons();
        }, this);
        this._panel.addChild(this._downButton);

        this._upButton = P3.Button.create(
            texture("btn_small_out"),
            texture("btn_small_out"),
            texture("btn_small_out"),
            texture("btn_icon_small_next")
        );
        this._upButton._icon.rotation = -90 * PIXI.DEG_TO_RAD;
        this._upButton.x = (panelSpr.width/2);
        this._upButton.y = 0;
        this._upButton.signals.click.add(() => {
            if (this._satchelPage.visible) {
                this._satchelPage.scroll(-1);
            } else if (this._equipPage.visible) {
                this._equipPage.scroll(-1);
            }
            this.assessScrollButtons();
        }, this);
        this._panel.addChild(this._upButton);

        this._satchelPage.fill(panelSpr);
        this._equipPage.fill(panelSpr);

        if(!this._satchelPage.checkScrollUp() && 
           !this._satchelPage.checkScrollDown() &&
           (settings.PHASE == 1 || 
            (!this._equipPage.checkScrollUp() &&
             !this._equipPage.checkScrollDown())
            )) {
            this._upButton.visible = this._upButton.interactive = this._downButton.visible = this._downButton.interactive = false;
        } else {
            this.showSatchelTab();
        }

        const m = this._satchelPage.areaMask;
        this._swiper = new Swiper({x:(common.STAGE_WIDTH / 2) - (m.width / 2), y:this._satchelPage.y + 200, width:m.width + 100, height:m.height});

        this.resize();

        this.animateShow();
    }

    animateShow()
    {
        this.animateTitleBannerIn();

        GameScene.active.addTween(gsap.to(this._bag, 0.3, {y:this._bag.y, ease:Expo.easeOut}));
        this._bag.y = common.STAGE_HEIGHT+this._bag.height;

        this._closeButton.scale.set(0);
        this._closeButton.interactive = false;

        GameScene.active.addTween(gsap.to(this._panel, 0.7, {delay:0.2, y:this._panel.y, ease:Expo.easeOut, onComplete:() => {
            this.animateCloseButtonIn();
        }}));
        this._panel.y = common.STAGE_HEIGHT + this._panel.height/2;

        this._coinHolder.scale.set(0);
        const coinHolderScale = settings.PHASE > 1 ? 0.75 : 1;
        GameScene.active.addTween(gsap.to(this._coinHolder.scale, 0.3, {x:coinHolderScale, y:coinHolderScale, ease:Expo.easeOut}));
    
        this._shopButton.scale.set(0);
        GameScene.active.addTween(gsap.to(this._shopButton.scale, 0.3, {x:1, y:1, ease: Sine.easeOut}));
    }

    animateHide(callback)
    {
        this._shopButton.interactive = false;

        this.animateFillOut();
        this.animateTitleBannerOut();

        GameScene.active.addTween(gsap.to(this._bag, 0.2, {delay:0.3, y:common.STAGE_HEIGHT+this._bag.height, ease:Sine.easeIn}));

        this.animateCloseButtonOut();

        GameScene.active.addTween(gsap.to(this._panel, 0.5, {y:common.STAGE_HEIGHT + this._panel.height/2, ease:Sine.easeIn, onComplete:() => {
            callback && callback();
        }}));

        GameScene.active.addTween(gsap.to(this._coinHolder.scale, 0.3, {x:0, y:0, ease:Expo.easeIn}));

        GameScene.active.addTween(gsap.to(this._shopButton.scale, 0.3, {x:0, y:0, ease: Sine.easeIn}));

        GameScene.active.addTween(gsap.to(this._ivandoe, 0.5, {y:common.STAGE_HEIGHT*1.5, ease:Sine.easeOut, onComplete:() => {
            if (this._ivandoe) {
                this._ivandoe.visible = false;
            }
        }}));
    }

    destroy() {
        this._closeButton.destroy();

        this._swiper.destroy();
        P3.audio.stopMusic();

        super.destroy();
    }

    update() {
        super.update();

        if(this.isSceneLoaded) {
            if (this._ivandoe) {
                this._ivandoe.update(window.dt);
            }
            if (this.healthBar) {
                this.healthBar.update();
            }

            this._swiper.update();
            if (!this._swiper.dragging && this._swiper.y != 0) {
                if (this._satchelPage.visible) {
                    this._satchelPage.scroll(Math.sign(-this._swiper.y));
                } else if (this._equipPage.visible) {
                    this._equipPage.scroll(Math.sign(-this._swiper.y));
                }
                this.assessScrollButtons();
                this._swiper.cancel();
            }
        }
    }

    resize(){
        super.resize();

        if (this.isSceneLoaded) {
            if (settings.PHASE > 1) {
                this._shopButton.position.set(
                    ((common.STAGE_WIDTH - P3.View.width + this._shopButton.defaultSize.width) * 0.5) + 15,
                    (this._shopButton.defaultSize.height * 0.5) + 30
                );
                this._coinHolder.x = this._shopButton.x + 5;
                this._coinHolder.y = this._titleBanner.y + 70;
            }
            this._resizePopUpFill();
        }
    }

    setIvandoeSkin() {
        const skin = new Skin("ivandoe_stance_normal");
        skin.addSkin(this._ivandoe.spineData.findSkin("normal"));
        skin.addSkin(this._ivandoe.spineData.findSkin("outfit_standard"));
        skin.addSkin(this._ivandoe.spineData.findSkin("belt_standard"));
        const data = json('equipment');
        for (let i in definitions.EQUIPPABLES) {
            if (common.saveData.activeSlot.player[definitions.EQUIPPABLES[i]]) {
                for (let j in data) {
                    for (let k in data[j]) {
                        if (data[j][k].id == common.saveData.activeSlot.player[definitions.EQUIPPABLES[i]]) {
                            for (let l in data[j][k].skins) {
                                skin.addSkin(this._ivandoe.spineData.findSkin(data[j][k].skins[l]));
                            }
                        }
                    }
                }
            }
        }
        if (common.saveData.activeSlot.player.weapon == null) {
            skin.addSkin(this._ivandoe.spineData.findSkin("equip_sword"));
        }
        this._ivandoe.skeleton.setSkin(skin);
        this._ivandoe.skeleton.setSlotsToSetupPose();

        GameScene.active.player.applySkins();
    }

    showSatchelTab() {
        this._satchelPage.visible = true;
        this._equipPage.visible = false;
        this.assessScrollButtons();
        this._satchelTab.tab.visible = true;
        this._equipTab.tab.visible = false;
        gsap.to(this._panel, 0.75, {x:(common.STAGE_WIDTH/2), ease:Expo.easeInOut});
        gsap.to(this._ivandoe, 0.3, {y:common.STAGE_HEIGHT*1.5, ease:Sine.easeOut, onComplete:() => {
            this._ivandoe.visible = false;
        }});
    }

    showEquipTab() {
        this._satchelPage.visible = false;
        this._equipPage.visible = true;
        this.assessScrollButtons();
        this._satchelTab.tab.visible = false;
        this._equipTab.tab.visible = true;
        gsap.to(this._panel, 0.75, {x:(common.STAGE_WIDTH/2)+75, ease:Expo.easeInOut});
        this._ivandoe.visible = true;
        gsap.to(this._ivandoe, 0.3, {y:common.STAGE_HEIGHT+30, ease:Sine.easeIn});
    }

    assessScrollButtons() {
        let page = this._satchelPage;
        if(this._equipPage.visible) {
            page = this._equipPage;
        }
        this._upButton.interactive = page.checkScrollUp();
        this._downButton.interactive = page.checkScrollDown();
        this._upButton.alpha = page.checkScrollUp() ? 1 : 0.5;
        this._downButton.alpha = page.checkScrollDown() ? 1 : 0.5;
    }

    showItemPanel(data, buttonText, callback) {

        if (this._swiper) {
            this._swiper.enabled = false;
        }

        this._popUpFill = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._popUpFill.tint = 0x29040e;
        this._popUpFill.alpha = 0;
        this._popUpFill.interactive = true;
        this.addChild(this._popUpFill);
        this._resizePopUpFill();

        const panel = new PIXI.NineSlicePlane(texture("panel_popup_9slice"), 80, 110, 80, 80);
        panel.width = 470;
        panel.height = 310;
        panel.x = (common.STAGE_WIDTH/2) - (panel.width/2);
        panel.y = common.STAGE_HEIGHT;
        this.addChild(panel);

        let title;
        if (!iswebfont()) {
            title = new PIXI.BitmapText(locale(data.name), {
                fontName: "Alghera Pro",
                fontSize: 40,
                align: "center",
                tint: 0x000000
            });
        } else {
            title = new PIXI.Text(locale(data.name), {
                fontFamily: "FredFredBurger",
                fontSize: 40,
                align: "center",
                fill: 0x0
            });
        }
        title.anchor.set(0.5);
        title.position.set(panel.width/2, !iswebfont() ? 60 : 57);
        panel.addChild(title);
        resizeLabelToFitText(title, panel.width-60);

        const image = new PIXI.Sprite(texture(data.image));
        if (data.type == 'weapon') {
            image.anchor.set(0.5, 0.5);
            image.position.set(panel.width - 30 - (image.width/2), 60 + (image.height/2));
            if (data.rotation) {
                image.rotation = data.rotation * PIXI.DEG_TO_RAD;
            }
        } else {
            image.anchor.set(0.5, 0.5);
            image.position.set(panel.width/2, 60 + (image.height/2));
        }
        panel.addChild(image);

        const bonusHolder = new PIXI.Container();
        bonusHolder.position.set(30, 120);
        panel.addChild(bonusHolder);

        if(data.stats.health != undefined && data.stats.health != 0) {
            let bonusLabel;
            if (!iswebfont()) {
                bonusLabel = new PIXI.BitmapText(locale("ui_shop_bonus").toUpperCase(), {
                    fontName: "Alghera Pro",
                    fontSize: 35,
                    align: "left",
                    tint: 0x000000
                });
            } else {
                bonusLabel = new PIXI.Text(locale("ui_shop_bonus").toUpperCase(), {
                    fontFamily: "FredFredBurger",
                    fontSize: 40,
                    align: "center",
                    fill: 0x0
                });
            }
            bonusHolder.addChild(bonusLabel);

            let addLabel;
            if (!iswebfont()) {
                addLabel = new PIXI.BitmapText(data.stats.health > 0 ? '+' : '-', {
                    fontName: "Alghera Pro",
                    fontSize: 35,
                    align: "left",
                    tint: 0x000000
                });
            } else {
                addLabel = new PIXI.Text(data.stats.health > 0 ? '+' : '-', {
                    fontFamily: "FredFredBurger",
                    fontSize: 40,
                    align: "center",
                    fill: 0x0
                });
            }
            addLabel.position.set(0, bonusLabel.height);
            bonusHolder.addChild(addLabel);
            let currentX = addLabel.width;
            for (let i = 0; i < Math.ceil(data.stats.health); i++) {
                let heart = new PIXI.Sprite(texture('icon_life_shield_on_100pc'));
                heart.x = currentX;
                heart.y = addLabel.y;
                bonusHolder.addChild(heart);
                if (i == Math.ceil(data.stats.health)-1) {
                    let decimal = data.stats.health - Math.floor(data.stats.health);
                    if (decimal > 0) {
                        heart.texture = texture("icon_life_shield_off");
                        let newHeart = new PIXI.Sprite(texture("icon_life_shield_on_" + String(decimal*100) + "pc"));
                        newHeart.x = heart.x;
                        newHeart.y = heart.y;
                        bonusHolder.addChild(newHeart);
                    }
                }
                currentX += heart.width;
            }
        }

        let description;
        if (!iswebfont()) {
            description = new PIXI.BitmapText(locale(data.description), {
                fontName: "Alghera Pro",
                fontSize: 30,
                align: "center",
                tint: 0x702311,
                maxWidth: panel.width-60
            });
        } else {
            description = new PIXI.Text(locale(data.description), {
                fontFamily: "FredFredBurger",
                fontSize: 30,
                align: "center",
                fill: 0x702311,
                wordWrap: true,
                wordWrapWidth: panel.width-60
            });
        }
        description.y = !iswebfont() ? 0 : -3;
        description.anchor.set(0.5, 0);
        description.position.set(panel.width/2, image.y + (image.height/2));
        panel.addChild(description);

        panel.height = Math.max(panel.height, description.y + description.height + panel.bottomHeight);

        const hidePanel = () => {
            this._tweens.push(
                gsap.to(panel, 0.3, {y:common.STAGE_HEIGHT, ease:Expo.easeIn, onComplete:() => {
                    this.removeChild(panel);
                }}),
                gsap.to(this._popUpFill, 0.2, {alpha:0, ease:Sine.easeIn, onComplete:() => {
                    this.removeChild(this._popUpFill);
                    this._popUpFill = null;
                }}),
            );
            if (this._swiper) {
                this._swiper.enabled = true;
            }
        }
        if (buttonText) {
            const equipButton = P3.Button.create(texture("btn_rectangle_out"));
                const backing = new PIXI.NineSlicePlane(texture("btn_rectangle_out"), 46, 20, 46, 20);
                backing.y = -backing.height/2;
                equipButton._background.addChild(backing);
            equipButton.overSoundName = "sfx_btn_generic_rollover";
            equipButton.clickSoundName = "sfx_btn_generic_press_00";

            let nameLabel;
            if (!iswebfont()) {
                nameLabel = new PIXI.BitmapText(locale(buttonText).toUpperCase(), {
                    fontName: "Alghera Pro Outline",
                    fontSize: 32,
                    align: "left",
                    tint: 0xFFFFFF
                });
            } else {
                nameLabel = new PIXI.Text(locale(buttonText).toUpperCase(), {
                    fontFamily: "FredFredBurger",
                    fontSize: 32,
                    align: "left",
                    fill: 0xFFFFFF
                });
            }
            nameLabel.y = !iswebfont() ? 0 : -3;
            nameLabel.anchor.set(0.5);
            equipButton._background.addChild(nameLabel);
            resizeLabelToFitText(nameLabel, 400);
            backing.width = nameLabel.width + (backing.leftWidth / (nameLabel.width > 180 ? 2 : 1)) + (backing.rightWidth / (nameLabel.width > 180 ? 2 : 1));
            backing.x = -backing.width/2;

            equipButton.x = (panel.width/2);
            equipButton.y = panel.height;
            panel.addChild(equipButton);

            this.signalListeners.push(
                equipButton.signals.click.add(() => {
                    if (callback) {
                        callback();
                    }
                    P3.audio.playSound("sfx_btn_item_equip_00");
                    hidePanel();
                }, this)
            )
        }

        const closeButton = P3.Button.create(
            texture("btn_small_out"),
            texture("btn_small_out"),
            texture("btn_small_out"),
            texture("btn_icon_cross"),
        );
        closeButton.x = panel.width;
        closeButton.y = 0;
        panel.addChild(closeButton);
        
        this.signalListeners.push(
            closeButton.signals.click.add(() => {
                hidePanel();
            }, this)
        );

        this._tweens.push(
            gsap.to(panel, 0.3, {y:(common.STAGE_HEIGHT / 2) - (panel.height/2), ease:Expo.easeOut}),
            gsap.to(this._popUpFill, 0.2, {alpha:0.3, ease:Sine.easeIn})
        );
    }

    addHealthBar() {
        if (this.healthBar == null) {
            this.healthBar = new HealthBar();
            this.healthBar.position.set(common.STAGE_WIDTH * 0.5, 0);
            this.addChild(this.healthBar);
        }
    }

    _resizePopUpFill(){
        if (this._popUpFill) {
            this._popUpFill.x = (common.STAGE_WIDTH - P3.View.width) * 0.5;
            this._popUpFill.width = P3.View.width;
            this._popUpFill.height = P3.View.height;
        }
    }

    /**
     * @return {Inventory}
     */
    get inventory() {
        return this._inventory;
    }
}

/**
 * @static
 * @type {InventoryScene}
 */
InventoryScene.active = null;